import { createSlice } from "@reduxjs/toolkit";
import { getCuisineAPI } from "../../api/cuisine";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getCuisineSlice = createSlice({
  name: "getCuisine",
  initialState: data,
  reducers: {
    getCuisineSlice(state) {
      state.isLoading = true;
    },
    getCuisineSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCuisineSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCuisineSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCuisineHandler =(search: any,page: any,limit: any,selectedStatus: any,sortField: any,sortDirection: any,role: any) => async (dispatch: any) => {
    try {
      dispatch(getCuisineAction.getCuisineSlice());
      const response: any = await getCuisineAPI(search,page,limit,selectedStatus,sortField,sortDirection,role);
      dispatch(getCuisineAction.getCuisineSliceSuccess(response));
    } catch (e: any) {
      dispatch(getCuisineAction.getCuisineSliceFailure(e?.response?.data));
    }
  };
export default getCuisineSlice.reducer;
export const getCuisineAction = getCuisineSlice.actions;
